import * as React from 'react'
import classNames from 'classnames'

import style from './style.scss'

export type Props = {
  age: number
  className?: string
  location: string
  name: string
}

HeroStats.defaultProps = {
  className: '',
}

function HeroStats(props: Props) {
  const { age, className, location, name } = props

  return (
    <div className={classNames(style.wrapper, className)}>
      <span className={style.nameAndAge}>
        {name}, {age}
      </span>
      <span className={style.location}>CrossFit {location}</span>
    </div>
  )
}

export default HeroStats
